'use client'

import { Skeleton } from '@/core/ui/atoms/skeleton'

export default function Loading() {
  return (
    <>
      <article className='relative mt-5 mb-16 hidden gap-10 px-2 md:flex'>
        <span className='flex flex-9 flex-col gap-10'>
          <Skeleton height='400px' borderRadius='1rem' />

          <div className='space-y-4'>
            <Skeleton height='24px' width='60%' />
            <Skeleton height='16px' width='100%' />
            <Skeleton height='16px' width='90%' />
            <Skeleton height='16px' width='95%' />
          </div>
        </span>

        <span className='sticky top-20 h-fit flex-3 space-y-6'>
          <Skeleton height='28px' width='70%' />

          <Skeleton height='24px' width='40%' />

          <div className='flex gap-2'>
            <Skeleton height='40px' width='120px' borderRadius='8px' />
            <Skeleton height='40px' width='120px' borderRadius='8px' />
          </div>

          <div className='space-y-2'>
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} height='16px' width={`${80 - i * 10}%`} />
            ))}
          </div>
        </span>
      </article>

      <article className='my-5 flex flex-col gap-10 px-2 md:hidden'>
        <Skeleton height='300px' borderRadius='1rem' /> {/* Slider */}
        <div className='space-y-4'>
          <Skeleton height='28px' width='70%' />
          <Skeleton height='24px' width='40%' />
          <div className='flex gap-2'>
            <Skeleton height='40px' width='120px' borderRadius='8px' />
            <Skeleton height='40px' width='120px' borderRadius='8px' />
          </div>
        </div>
        <div className='space-y-2'>
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} height='16px' width={`${80 - i * 10}%`} />
          ))}
        </div>
        <div className='space-y-4'>
          <Skeleton height='24px' width='60%' />
          <Skeleton height='16px' width='100%' />
          <Skeleton height='16px' width='90%' />
          <Skeleton height='16px' width='95%' />
        </div>
      </article>
    </>
  )
}
